import { render, staticRenderFns } from "./contentCenter.vue?vue&type=template&id=93583f7c&scoped=true"
import script from "./contentCenter.vue?vue&type=script&lang=js"
export * from "./contentCenter.vue?vue&type=script&lang=js"
import style0 from "./contentCenter.vue?vue&type=style&index=0&id=93583f7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93583f7c",
  null
  
)

export default component.exports